import React from 'react'

export default function AylaLoading({ className }) {
  return (
    <div className={className}>
      <img src="https://www-yns-com.s3.us-east-2.amazonaws.com/images/alya_loading.gif" />
    </div>
  )
}
